import type {
  DataSourceProps,
  DynamicDataSourceProps,
  StaticDataSourceProps
} from '../types';

export const transformDataSource = (dataSource: DataSourceProps) =>
  Array.isArray(dataSource)
    ? ({ data: dataSource } as StaticDataSourceProps)
    : (dataSource as DynamicDataSourceProps | StaticDataSourceProps);
